import React from 'react';
import { Redirect, Route } from 'react-router';

import {
  LoadableCookiePolicy,
  LoadableLogin,
  LoadableLoginCallback,
  LoadableCognitoLoginCallback,
  LoadableLogout,
} from './helpers/loadables';

export default (
  <>
    {/* Auth */}
    <Route path="/login" component={LoadableLogin} />
    <Route path="/login/callback" component={LoadableLoginCallback} />
    <Route
      path="/login/cognito/callback"
      component={LoadableCognitoLoginCallback}
    />
    <Route path="/logout" component={LoadableLogout} />
    <Route path="/cookie-policy" component={LoadableCookiePolicy} />

    {/* Auth variations */}
    <Redirect from="/find" to="/login" />
  </>
);
